import {platformAPI} from "../../../api/axiosConfig";

export type CountryAvailability = {
    countryCode: string;
    sms: boolean;
    call: boolean;
};

export async function getCountryAvailability(params: {clientID?: string}): Promise<CountryAvailability[]> {
    try {
        const res = await platformAPI.get<CountryAvailability[]>("api/siren/country-availability", {params});
        return res.data;
    } catch {
        return [];
    }
}
